/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_EndInputs */

const en_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap to Event End`)
};

const fr_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner sur la fin de l'événement`)
};

const de_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Ereignisende einrasten`)
};

const it_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggancia alla fine dell'evento`)
};

const ru_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к завершению события`)
};

const es_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar al final del evento`)
};

const zh_cn2_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捕捉到事件结束`)
};

const ja_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの終了にスナップ`)
};

const hi_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समाप्त होने पर क्लिक करें`)
};

const pt_pt2_snap_to_event_end = /** @type {(inputs: Snap_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar ao fim do evento`)
};

/**
* | output |
* | --- |
* | "Snap to Event End" |
*
* @param {Snap_To_Event_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_end = /** @type {((inputs?: Snap_To_Event_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_event_end(inputs)
	if (locale === "de") return de_snap_to_event_end(inputs)
	if (locale === "it") return it_snap_to_event_end(inputs)
	if (locale === "ru") return ru_snap_to_event_end(inputs)
	if (locale === "es") return es_snap_to_event_end(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_event_end(inputs)
	if (locale === "ja") return ja_snap_to_event_end(inputs)
	if (locale === "hi") return hi_snap_to_event_end(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_event_end(inputs)
	return en_snap_to_event_end(inputs)
});